import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import SuccessIcon from "../../assets/icons/sucess.svg";
import { useNavigate } from "react-router-dom";
import "./GuestOrderSuccess.scss";
import ADL_Sidebar_Logo from "../../assets/images/ADL_Logo_White.webp";
import LoginIcon from '@mui/icons-material/Login';

interface GuestOrderSuccessProps {
  orderId: string | number;
  orderDate: string;
  onContinue: () => void;
}

const GuestOrderSuccess: React.FC<GuestOrderSuccessProps> = ({
  orderId,
  orderDate,
  onContinue,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  return (
    <>
    <Box
        className="drawer-logo" width={"100%"}
        sx={{
          display: "flex",
          alignItems: "left",
          justifyContent: "normal",
          backgroundColor: " #014C8A",
          padding: "35px 20px",
          marginBottom: "15px",
          color: "white"
        }}
      >
       <Typography style={{width:"35%"}}>
        <img
          className={"sidebar-logo"}
          src={ADL_Sidebar_Logo}
          style={{
            transition: "width 0.15s",
            height: 55,
            width: "auto",
            objectFit: "contain",
            display: "block"
          }}
          alt="ADL Logo"
        />
        </Typography>
        <Typography variant="h4" style={{fontWeight:"500", width:"60%"}}>Order Replacement Labels</Typography>
        <Typography  style={{fontWeight:"500", width:"5%", textAlign:"right"}}><a style={{color:"white"}} href={process.env.REACT_APP_LKQPORTAL_URL}><LoginIcon/></a></Typography>
        
      </Box>
    <Card className="order-success-card">
      <CardContent>
        
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          p={2}
        >
          <img src={SuccessIcon} alt="Success icon"></img>
          <Typography
            className="success-msg"
            fontSize={isMobile ? "18px" : "24px"}
            variant="h5"
            gutterBottom
          >
            Your Order is Successfully Placed
          </Typography>
        </Box>
        <Typography className="success-description" variant="body1" style={{textAlign:"center"}}>
          <div><strong>Thank you for your label order.</strong> We are processing it and will notify you if we require any additional information.</div>
          <div>  You will receive a shipping notification and an invoice when your order ships.</div> 
          <div>If you have any questions, please reach out to us at <a href='mailto:adlcustomerservice@lkqcorp.com?subject=subject&body=body' target="_blank">adlcustomerservice@lkqcorp.com</a></div>
        </Typography>
        <Box pt={2} display="flex" flexDirection="row" flexWrap="wrap" gap={1} alignItems="center"
          justifyContent="center">
          <Typography component="span" fontWeight={600}>
            Order #:
          </Typography>
          <Typography component="span" sx={{ color: "#918F8F" }}>
            {orderId}
          </Typography>

          {orderDate && (
            <>
              <Typography component="span" fontWeight={600} ml={1}>
                {`|  Placed on`}
              </Typography>
              <Typography component="span" sx={{ color: "#918F8F" }}>
                {orderDate}
              </Typography>
            </>
          )}
        </Box>
        <Box
          pt={2}
          display="flex"
          gap={2}
          flexDirection={isMobile ? "column" : "row"} alignItems="center"
          justifyContent="center"
        >
          <Button
            className="outlined-btn"
            variant="outlined"
            fullWidth={isMobile}
            onClick={onContinue}
          >
            Continue
          </Button>
        </Box>
      </CardContent>
    </Card>
    </>
  );
};

export default GuestOrderSuccess;
